// App resources: icons, images, fonts...
const AppResource = {
  // icons
  icons: {},

  // images
  images: {
    // img_registered_ministry_trade: require("assets/images/img_registered_ministry_trade.png"),
    imgDefault: require("../../assets/images/imgDefault.jpg"),
    // logoImg: require("../../assets/images/logoImg.png"),
    img_banner1: require("../../assets/images/banner1.jpg"),
    img_banner2: require("../../assets/images/banner-2.png"),
    img_banner3: require("../../assets/images/banner-3.png"),
    img_banner4: require("../../assets/images/banner-4.jpg"),
    img_banner5: require("../../assets/images/banner-5.jpg"),
    img_soup_cate: require("../../assets/images/img_soup.jpg"),
    img_cake_cate: require("../../assets/images/img_cake.jpg"),
    img_braised_dish_cate: require("../../assets/images/img_braised_dish.jpg"),
    img_fried_food_cate: require("../../assets/images/img_fried_food.jpg"),
    img_grill_cate: require("../../assets/images/img_grill.jpg"),
    img_porridge_cate: require("../../assets/images/img_porridge.jpg"),
    img_steamed_dish_cate: require("../../assets/images/img_steamed_dish.jpg"),
    img_stir_fried_meal: require("../../assets/images/img_stir_fried_meal.jpg"),
    img_logo: require("../../assets/images/logo.png"),
    img_no_data: require("../../assets/images/img_no_data.jpg"),
    img_pho: require("../../assets/images/img_pho.jpg"),
    img_banh_my: require("../../assets/images/img_banh_my.jpg"),
    img_bun_cha: require("../../assets/images/img_bun_cha.jpg"),
    img_rau_muong: require("../../assets/images/img_rau_muong.jpg"),
  },

  // colors
  colors: {
    primary: "#E31D93",
    secondary: "#19D3C5",
    secondary02: "#0071CE",
    feature: "#E31D93",
    darkGrey: "#262224",
    grey: "#5A5C6F",
    grey50: "#ACACBB",
    lightGreyStroke: "#E0E2ED",
    lineIndicator: "#E8EFF4",
    lightGrey50: "#F1F5F8",
    white: "#ffffff",
    featureBlue: "#0066C7",
    featureYellow: "#FF9427",
    featureGreen: "#18CDBD",
    red: "#CD1F13",
    textSecondary: "#6B686A",
    textPrimary: "#262224",
    placeholder: "#A8A8A8",
    black: "#000",
    error01: "#9E0038",
    success: "#0071CE",
    neutral: "#EBEBEB",
  },
};

export default AppResource;
